module.exports = __webpack_public_path__ + "static/media/amex-svgrepo-com.a9eddb34.svg";